export default __webpack_public_path__ + "static/1-37-0-compression-97aad07904b95dcab7ee794c1cfa5456.png";